import { render, staticRenderFns } from "./NsTaxId.vue?vue&type=template&id=7f4b0fb4&scoped=true&"
import script from "./NsTaxId.vue?vue&type=script&lang=js&"
export * from "./NsTaxId.vue?vue&type=script&lang=js&"
import style0 from "./NsTaxId.vue?vue&type=style&index=0&id=7f4b0fb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4b0fb4",
  null
  
)

export default component.exports